export default "__VITE_ASSET__DC39KWW5__"